
import {createContext } from "react"
const SaleContext =createContext({
    saleName:"default sale"
})
export default SaleContext;